/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, September 2020
 *
 *****************************************************************************/

import React from "react";
import { Marker, Polyline } from "react-google-maps";
import { busMarker } from "../../../shared/utlilty";

// show live vehicles with its paths
const LiveVehicle = (props) => {
  let vehicles = [];
  let tracks = [];
  for (let c of props.coordinates) {
    if (c.pos.length == 0) continue;
    
    vehicles.push(
      <Marker
        key={c.key}
        clickable={true}
        animation={global.google.maps.Animation.DROP}
        onClick={() => props.selectVehicle(c.key, c.equipmentId, "marker")}
        position={{
          lat: c.pos[c.pos.length - 1].lat,
          lng: c.pos[c.pos.length - 1].lng,
        }}
        icon={{
          url: busMarker(c.key === props.selectedKey, c.status),
          anchor: {
            x: 25,
            y: 25,
          },
        }}
      />
    );

    let path = JSON.stringify(c.pos);
    path = JSON.parse(path);

    tracks.push(
      <Polyline
        key={c.key}
        path={path}
        draggable={false}
        editable={false}
        options={{
          strokeWeight: 5,
          strokeColor: c.key === props.selectedKey ? "#f36f86" : "blue",
          zIndex: 1,
        }}
      />
    );
  }
  return (
    <>
      {vehicles}
      {tracks}
    </>
  );
};

export default React.memo(LiveVehicle);
